import AxiosFactory from "@/repositories/AxiosFactory";

const resource = "/pending-users";

export default {
  delete(id) {
    return AxiosFactory.delete(`${resource}/${id}`);
  }
};
